import { BaseModel } from "sjs-base-model";

export default class DatiAnagraficiModel extends BaseModel {
    public readonly codiceFiscaleDipendente: string = "";
    public readonly cognomeDipendente: string = "";
    public readonly nomeDipendente: string = "";
    public readonly dataNascitaDipendente: string = "";
    public readonly provinciaNascita: string = "";
    public readonly comuneNascita: string = "";
    public readonly indirizzoResidenza: string = "";
    public readonly provinciaResidenza: string = "";
    public readonly comuneResidenza: string = "";
    public readonly capResidenza: string = "";
    public readonly iscrizione: string = "";
    public readonly enteAppartenenza: string = "";
    public readonly sedeLavoro: string = "";
    public readonly indirizzoSedeLavoro: string = "";
    public readonly provinciaSedeLavoro: string = "";
    public readonly comuneSedeLavoro: string = "";
    public readonly capSedeLavoro: string = "";
    public readonly codUfficioResponsabile: string = "";
    public readonly ufficioResponsabile: string = "";
    public readonly indirizzoUffResp: string = "";
    public readonly provinciaUffResp: string = "";
    public readonly comuneUffResp: string = "";
    public readonly capUffResp: string = "";
    public readonly codFiscUffResp: string = "";

    constructor(data: Partial<DatiAnagraficiModel>) {
        super();

        this.update(data);
    }
}
